export const SHOP = {
  company: "K-RAPAT",
  legalForm: "SASU",
  siret: "532 766 664 00017",
  vat: "FR06532766664",
  director: "Pascal Chaubo",
  address: "25 rue de Ponthieu, 75008 Paris",
  phone: "06 25 99 55 02",
  tel: "+33625995502",
  email: "pchaubo@hotmail.fr",
  rating: "4,9",
  shipDelay: "Expédition sous 72 h maximum",
};
